import { render, staticRenderFns } from "./reportTable.vue?vue&type=template&id=65b07f14&scoped=true&"
import script from "./reportTable.vue?vue&type=script&lang=js&"
export * from "./reportTable.vue?vue&type=script&lang=js&"
import style0 from "./reportTable.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./reportTable.vue?vue&type=style&index=1&id=65b07f14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b07f14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VIcon,VLayout})
